import React, {useEffect, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import IconCheck from '../../assets/icons/check.svg?react'

// Small floating menu toggling the only status transition an agency can make
// manually today (código entregado / sin entregar) — mirrors the design's
// `menu` popover, restricted to the two states that are actually editable.
export const CodeStatusMenu: React.FC<{
    delivered: boolean
    disabled?: boolean
    onChange: (delivered: boolean) => void
    onClose: () => void
}> = ({delivered, disabled, onChange, onClose}) => {
    const {t} = useTranslation('dashboard')
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) onClose()
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [onClose])

    const options: {label: string; value: boolean}[] = [
        {label: t('packs.statusNotDelivered'), value: false},
        {label: t('packs.statusDelivered'), value: true},
    ]

    return (
        <div ref={ref} className="absolute z-30 top-full left-0 mt-1.5 min-w-[172px] bg-white border border-neutralBlack-200 rounded-xl shadow-lg p-1.5 flex flex-col gap-0.5">
            <span className="text-[11px] text-neutralBlack-400 px-2 pt-1 pb-0.5">{t('packs.markStatus')}</span>
            {options.map((o) => (
                <button
                    key={String(o.value)}
                    type="button"
                    disabled={disabled}
                    onClick={(e) => {
                        e.stopPropagation()
                        onChange(o.value)
                        onClose()
                    }}
                    className={`flex items-center gap-2 px-2.5 py-2 rounded-lg text-[13px] text-neutralBlack-900 text-left hover:bg-neutralBlack-100 disabled:opacity-50 ${delivered === o.value ? 'bg-neutralBlack-100' : ''}`}
                >
                    <span className="w-2.5 h-2.5 flex-none">{delivered === o.value && <IconCheck className="size-2.5"/>}</span>
                    {o.label}
                </button>
            ))}
        </div>
    )
}
